module.exports = __webpack_public_path__ + "static/img/icon4_about.eb597f3a.png";